import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PrivateRoute from './PrivateRoute'
import { actions } from '../../../store'

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user,
  modal: state.modal
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getUsers: actions.user.getUsers,
  getStorage: actions.storage.getStorage,
  getChannels: actions.channel.getChannels,
  getGroups: actions.group.getGroups,
  getTags: actions.tag.getTags
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/components/Layout/PrivateRoute/index.js